import React, { useEffect, useState } from "react"
import moment from "moment"
import MonthView from "./components/MonthView"
import DayView from "./components/DayView"
import WeekView from "./components/WeekView"
import "./AppointmentCalendar.scss"
import AppointmentCalendarUtils from "./AppointmentCalenderUtils"
import CalendarPicker from "./components/CalendarPicker"

export default function AppointmentCalendar({
  includeIpdOpdDivision,
  appointments,
  updateDateRange,
  onButtonClick,
  outline,
  dropdown,
  onDropdownChange,
  userRole,
  centerDetail,
  show,
  updateSelectedModeMain,
  updateSelectedItemMain
}: any) {
  const [selectedMode, updateSelectedMode] = useState<string>("Day")
  const [selectedItem, updateSelectedItem] = useState<any>()
  const [displayString, updateDisplayString] = useState<any>()
  const [slots, updateSlots] = useState<any>()

  useEffect(() => {
    updateSelectedModeMain(selectedMode)
    updateSelectedItemMain(selectedItem)
  }, [selectedMode, selectedItem])

  useEffect(() => {
    if (centerDetail) {
      let tempSlots = AppointmentCalendarUtils.createTimeSlots(
        centerDetail?.openTime,
        centerDetail?.closeTime,
        centerDetail?.slotDuration
      )
      // console.log(centerDetail, "tempSlots")
      updateSlots(tempSlots)
    }
  }, [centerDetail])


  useEffect(() => {
    let temp = moment().format("YYYY-MM-DD")
    updateSelectedItem(temp)
  }, [])

  useEffect(() => {
    if (selectedItem && selectedMode) {
      renderSelectedItem()
      let obj = AppointmentCalendarUtils.fetchStartAndEndDate(
        selectedItem,
        selectedMode
      )
      updateDateRange({ startDate: obj?.startDate, endDate: obj?.endDate })
    }
  }, [selectedItem, selectedMode])

  function renderSelectedItem() {
    let displayString = AppointmentCalendarUtils.renderSelectedItem(
      selectedMode,
      selectedItem
    )
    updateDisplayString(displayString)
  }

  function changeDay(day: any) {
    updateSelectedItem(moment(day).format("YYYY-MM-DD"))
    updateSelectedMode("Day")
  }

  return (
    <div className="appointment-calendar-wrapper">
      <CalendarPicker
        displayString={displayString}
        selectedItem={selectedItem}
        selectedMode={selectedMode}
        updateSelectedItem={updateSelectedItem}
        updateSelectedMode={updateSelectedMode}
        displayModes={true}
        dropdown={dropdown}
        onDropdownChange={(event: any) => onDropdownChange(event)}
      />
      {selectedMode === "Day" && (
        <DayView
          includeIpdOpdDivision={includeIpdOpdDivision}
          currentlySelected={selectedItem}
          appointments={appointments}
          onButtonClick={onButtonClick}
          outline={outline}
          userRole={userRole}
          slots={slots}
          slotDuration={centerDetail?.slotDuration}
          bedSlotDuration={centerDetail?.bedSlotDuration}
          show={show}
        />
      )}
      {selectedMode === "Week" && (
        <WeekView
          includeIpdOpdDivision={includeIpdOpdDivision}
          currentlySelected={selectedItem}
          appointments={appointments}
          onButtonClick={onButtonClick}
          changeDay={changeDay}
          outline={outline}
          userRole={userRole}
          slots={slots}
          slotDuration={centerDetail?.slotDuration}
          bedSlotDuration={centerDetail?.bedSlotDuration}
          show={show}
        />
      )}
      {selectedMode === "Month" && (
        <MonthView
          includeIpdOpdDivision={includeIpdOpdDivision}
          currentlySelected={selectedItem}
          appointments={appointments}
          onButtonClick={onButtonClick}
          changeDay={changeDay}
          outline={outline}
          userRole={userRole}
          slotDuration={centerDetail?.slotDuration}
          bedSlotDuration={centerDetail?.bedSlotDuration}
          show={show}
        />
      )}
    </div>
  )
}
